// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/TokensAndPots/Status.css
// module id = 3071
// module chunks = 0